exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-106c86ed]{margin:30px}.dashboard-text[data-v-106c86ed]{font-size:30px;line-height:46px}.dashboard-bottom[data-v-106c86ed]{margin-top:30px;margin-left:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dashboard-image2[data-v-106c86ed]{width:500px;height:400px}.dashboard-xinhanfang_introduce[data-v-106c86ed]{font-size:14px;line-height:1.7rem;-webkit-box-flex:1;-ms-flex:1;flex:1;margin-left:20px;padding:20px}\n", ""]);

// exports
